import React, { useState } from "react";
import { useParams } from "react-router-dom";
import quizImg from "../../images/quizImg.png";
import { useContext } from "react";
import { appContext } from "../../App";
import check from "../../images/check.svg";
import cross from "../../images/cross.svg";
import crossblack from "../../images/crossblack.svg";
import checkblack from "../../images/checkblack.svg";


function Quiz() {
  const { id } = useParams();
  
  let renderQuestion = [];

  const { setNavToggle } = useContext(appContext);

  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [checkAnswer, setCheckAnswer] = useState("wrong");
  const [score, setScore] = useState(0);
  const [result, setResult] = useState(false);
  const [showAnswers, setShowAnswers] = useState(false);
  const [optionSelected, setOptionSelected] = useState("");
  const [userAnswers, setUserAnswers] = useState([]);
  const [optionBgColor, setOptionBgColor] = useState(null);

  const HTML = [
    {
      question: "What does HTML stand for?",
      options: [
        "Hypertext Markup Language",
        "Hyperlink Markup Language",
        "Hypermedia Markup Language",
        "High-level Markup Language",
      ],
      answer: "Hypertext Markup Language",
    },
    {
      question: "What is the purpose of HTML?",
      options: [
        "To format and display text on web pages",
        "To create animations on web pages",
        "To create and run programs on web pages",
        "To store and organize data on web pages",
      ],
      answer: "To format and display text on web pages",
    },
    {
      question: "What is the main building block of an HTML document?",
      options: ["Hyperlink", "Header", "Image", "Element"],
      answer: "Element",
    },
    {
      question: "Which of the following HTML tags is used to create a table?",
      options: ["table", "row", "column", "cell"],
      answer: "table",
    },
    {
      question: "What is the correct way to write a doctype for HTML5?",
      options: [
        "<!DOCTYPE HTML5>",
        "<!DOCTYPE html5>",
        "<!DOCTYPE HTML 5>",
        "<!DOCTYPE html 5>",
      ],
      answer: "<!DOCTYPE HTML5>",
    },
    {
      question: "What is the purpose of the alt attribute in an HTML img tag?",
      options: [
        "To provide a description of the image for visually impaired users.",
        "To provide an alternate image source in case the main image source fails to load.",
        "To provide a title for the image.",
        "To provide a caption for the image.",
      ],
      answer:
        "To provide a description of the image for visually impaired users.",
    },
    {
      question: "How do you create a hyperlink in HTML?",
      options: ["<a>", "<link>", "<hyperlink>", "<href>"],
      answer: "<a>",
    },
    {
      question: "Which of the following is a void element in HTML?",
      options: ["img", "table", "input", "text"],
      answer: "img",
    },
    {
      question: "What does the <ol> tag represent in HTML?",
      options: [
        "Ordered List",
        "Ordered List Item",
        "Ordered Number List",
        "Ordered Numbered List",
      ],
      answer: "Ordered List",
    },
    {
      question:
        "What is the correct syntax for creating an internal CSS in an HTML file?",
      options: [
        "<style src='style.css'>",
        "<style href='style.css'>",
        "<style type='text/css'>",
        "<style>",
      ],
      answer: "<style type='text/css'>",
    },
    {
      question: "What is the use of <!DOCTYPE> declaration in HTML?",
      options: [
        "It specifies the version of HTML used in the document",
        "It specifies the encoding used in the document",
        "It is used to force a new page",
        "It is used to define a stylesheet for the document",
      ],
      answer: "It specifies the version of HTML used in the document",
    },
    {
      question: "What is the correct way to write a self-closing tag in HTML5?",
      options: ["<tag />", "<tag>", "<tag></tag>", "None of the above"],
      answer: "<tag />",
    },
    {
      question:
        "Which of the following is the correct way to link a CSS file to an HTML document?",
      options: [
        "<link type='text/css' href='style.css'>",
        "<style src='style.css'>",
        "<link rel='stylesheet' href='style.css'>",
        "<style type='text/css' href='style.css'>",
      ],
      answer: "<link rel='stylesheet' href='style.css'>",
    },
    {
      question:
        "How do you specify a section of a web page that should have the same style properties as another section of the page?",
      options: [
        "Use JavaScript to copy the styles from one section to another",
        "Use an HTML <copy> tag",
        "Use an HTML <style> tag",
        "Use an HTML <link> tag",
      ],
      answer: "Use an HTML <link> tag",
    },
    {
      question:
        "Which of the following is used to display a caption for a <figure> element?",
      options: [
        "<figcaption>",
        "<caption>",
        "<figurecaption>",
        "<figcaptioning>",
      ],
      answer: "<figcaption>",
    },
  ];

  const Javascript = [
    {
      question: "What is the type of NaN in JavaScript?",
      options: ["Number", "String", "Boolean", "Object"],
      answer: "Number",
    },
    {
      question: "What is the syntax to declare a variable in JavaScript?",
      options: ["var x = 10;", "variable x = 10;", "x := 10;", "let x = 10;"],
      answer: "var x = 10;",
    },
    {
      question: "What is a closure in JavaScript?",
      options: [
        "A function that executes automatically when it is defined.",
        "A function that returns another function.",
        "A function that executes only when it is called.",
        "A function that can access variables in its outer scope.",
      ],
      answer: "A function that can access variables in its outer scope.",
    },
    {
      question: "What is the difference between let and var in JavaScript?",
      options: [
        "let is block-scoped, var is function-scoped.",
        "var is block-scoped, let is function-scoped.",
        "let and var have the same scope.",
        "None of the above.",
      ],
      answer: "let is block-scoped, var is function-scoped.",
    },
    {
      question: "What is a Promise in JavaScript?",
      options: [
        "An object that may produce a single value some time in the future",
        "A function that returns a value",
        "A value that may be available now or in the future",
        "None of the above",
      ],
      answer:
        "An object that may produce a single value some time in the future",
    },
    {
      question: "How can you make a shallow copy of an object in JavaScript?",
      options: [
        "Using JSON.stringify and JSON.parse",
        "Using the spread operator",
        "Using Object.assign",
        "None of the above",
      ],
      answer: "Using the spread operator",
    },
    {
      question: "What is hoisting in JavaScript?",
      options: [
        "Moving a variable to the top of its scope",
        "Moving a variable to the bottom of its scope",
        "Deleting a variable from its scope",
        "None of the above",
      ],
      answer: "Moving a variable to the top of its scope",
    },
    {
      question: "What is the difference between == and === in JavaScript?",
      options: [
        "== performs type coercion, === does not.",
        "=== performs type coercion, == does not.",
        "Both == and === perform type coercion.",
        "Neither == nor === perform type coercion.",
      ],
      answer: "== performs type coercion, === does not.",
    },
    {
      question: "What is the correct way to write a JavaScript array?",
      options: [
        "var colors = 1 = ('red', 'green', 'blue')",
        "var colors = ['red', 'green', 'blue']",
        "var colors = 'red', 'green', 'blue'",
        "var colors = (1) = ('red', 'green', 'blue')",
      ],
      answer: "var colors = 1 = ('red', 'green', 'blue')",
    },
    {
      question: "What is a higher-order function in JavaScript?",
      options: [
        "A function that executes automatically when it is defined.",
        "A function that returns another function.",
        "A function that executes only when it is called.",
        "A function that can access variables in its outer scope.",
      ],
      answer: "A function that returns another function.",
    },
    {
      question: "What is a pure function in JavaScript?",
      options: [
        "A function that does not modify its inputs.",
        "A function that does not modify any variables outside of its scope.",
        "A function that only returns values and does not perform any side effects.",
        "All of the above.",
      ],
      answer: "All of the above.",
    },
    {
      question:
        "What is the difference between null and undefined in JavaScript?",
      options: [
        "null is a value, undefined is a value.",
        "undefined is a value, null is a value.",
        "null and undefined are the same thing.",
        "null and undefined have different values.",
      ],
      answer: "null and undefined have different values.",
    },
    {
      question: "What is an IIFE in JavaScript?",
      options: [
        "A function that executes automatically when it is defined.",
        "A function that returns another function.",
        "An Immediately Invoked Function Expression",
        "A function that can access variables in its outer scope.",
      ],
      answer: "An Immediately Invoked Function Expression",
    },

    {
      question:
        "How do you add an element to the end of an array in JavaScript?",
      options: [
        "array.end(element)",
        "array.push(element)",
        "array.append(element)",
        "array[array.length] = element",
      ],
      answer: "array.push(element)",
    },
    {
      question: "What does the 'this' keyword refer to in JavaScript?",
      options: [
        "The function being executed",
        "The object that the function is a property of",
        "The global object",
        "The previous object",
      ],
      answer: "The object that the function is a property of",
    },
    {
      question: "What is the result of the following code: typeof null;",
      options: ["null", "undefined", "object", "string"],
      answer: "object",
    },
    {
      question: "How do you declare a function in JavaScript?",
      options: [
        "function myFunction() {}",
        "var myFunction = function() {}",
        "let myFunction = function() {}",
        "const myFunction = function() {}",
      ],
      answer: "function myFunction() {}",
    },
    {
      question: "What is the purpose of 'use strict' in JavaScript?",
      options: [
        "To turn on strict mode for the current script",
        "To turn off strict mode for the current script",
        "To enforce coding best practices and prevent certain errors",
        "To optimize the performance of the code",
      ],
      answer: "To enforce coding best practices and prevent certain errors",
    },
    {
      question:
        "What is the difference between null and undefined in JavaScript?",
      options: [
        "null is a value, undefined is a variable",
        "undefined is a value, null is a variable",
        "Both null and undefined are values",
        "Both null and undefined are variables",
      ],
      answer: "null is a value, undefined is a variable",
    },
    {
      question: "What is a callback function in JavaScript?",
      options: [
        "A function that is passed as an argument to another function",
        "A function that returns another function",
        "A function that is called after the completion of a synchronous function",
        "A function that is called only once",
      ],
      answer: "A function that is passed as an argument to another function",
    },
  ];

  const ReactJs = [
    {    question: "What is ReactJS used for?",    options: [      "Creating dynamic user interfaces",      "Server-side rendering",      "Building mobile applications",      "All of the above"    ],
    answer: "Creating dynamic user interfaces"
  },
  {
    question: "What is the virtual DOM in ReactJS?",
    options: [
      "A real DOM",
      "A virtual representation of the DOM",
      "A framework for building user interfaces",
      "None of the above"
    ],
    answer: "A virtual representation of the DOM"
  },
  {
    question: "What is JSX in ReactJS?",
    options: [
      "JavaScript XML",
      "A framework for building user interfaces",
      "A virtual representation of the DOM",
      "None of the above"
    ],
    answer: "JavaScript XML"
  },
  {
    question: "What is a component in ReactJS?",
    options: [
      "A building block of a ReactJS user interface",
      "A framework for building user interfaces",
      "A virtual representation of the DOM",
      "None of the above"
    ],
    answer: "A building block of a ReactJS user interface"
  },
  {
    question: "What is state in ReactJS?",
    options: [
      "A JavaScript object containing data or information about a component",
      "A virtual representation of the DOM",
      "A framework for building user interfaces",
      "None of the above"
    ],
    answer: "A JavaScript object containing data or information about a component"
  },
  {    question: "What is the difference between props and state in ReactJS?",    options: [      "Props are mutable while state is immutable",      "Props are immutable while state is mutable",      "Both props and state are mutable",      "Both props and state are immutable"    ],
    answer: "Props are immutable while state is mutable"
  },
  {
    question: "What is the purpose of shouldComponentUpdate lifecycle method in ReactJS?",
    options: [
      "To update the component when its state changes",
      "To update the component when its props change",
      "To control whether a component re-renders when its props or state change",
      "To optimize the component's performance by preventing unnecessary re-renders"
    ],
    answer: "To optimize the component's performance by preventing unnecessary re-renders"
  },
  {
    question: "What is the purpose of Virtual DOM in ReactJS?",
    options: [
      "To store the component's actual DOM node",
      "To store a lightweight in-memory representation of a component's DOM",
      "To manipulate the actual DOM directly",
      "To manage component events"
    ],
    answer: "To store a lightweight in-memory representation of a component's DOM"
  },
  {
    question: "What is the difference between class component and functional component in ReactJS?",
    options: [
      "Class components can have state while functional components cannot",
      "Functional components can have state while class components cannot",
      "Class components can have lifecycle methods while functional components cannot",
      "Functional components are more performant than class components"
    ],
    answer: "Class components can have state while functional components cannot"
  },
  {
    question: "What is the difference between server-side rendering and client-side rendering in ReactJS?",
    options: [
      "Server-side rendering generates the HTML on the server and sends it to the client, while client-side rendering generates the HTML on the client using JavaScript",
      "Client-side rendering generates the HTML on the server and sends it to the client, while server-side rendering generates the HTML on the client using JavaScript",
      "Server-side rendering is faster than client-side rendering",
      "Client-side rendering is faster than server-side rendering"
    ],
    answer: "Server-side rendering generates the HTML on the server and sends it to the client, while client-side rendering generates the HTML on the client using JavaScript"
  },
  {
    "question": "What is the purpose of render() method in ReactJS?",
    "options": [
      "To specify the layout of a React component",
      "To initialize the state of a React component",
      "To specify how the component should update when its props change",
      "To render the component and return a tree of React elements"
    ],
    "answer": "To render the component and return a tree of React elements"
  },
  {
    "question": "Which of the following is the preferred way of binding the this keyword in ReactJS?",
    "options": [
      "Using bind() method",
      "Using call() method",
      "Using apply() method",
      "Using arrow functions"
    ],
    "answer": "Using arrow functions"
  },
  {
    "question": "What is the difference between state and props in ReactJS?",
    "options": [
      "Props are read-only, while state can be modified",
      "State is read-only, while props can be modified",
      "Props and state are both read-only",
      "Props and state can both be modified"
    ],
    "answer": "Props are read-only, while state can be modified"
  },
  {
    "question": "What is the correct way to initialize the state of a React component?",
    "options": [
      "this.state = {};",
      "this.state = ();",
      "this.setState = {};",
      "this.setState = ();"
    ],
    "answer": "this.state = {};"
  },
  {
    "question": "What is the correct way to pass a value from a parent component to a child component in React?",
    "options": [
      "By using a global variable",
      "By using props",
      "By using state",
      "None of the above"
    ],
    "answer": "By using props"
  },


  ]


  const CSS = [
    {    question: "What is the default value of the 'position' property in CSS?",    options: [      "absolute",      "relative",      "fixed",      "static"    ],
    answer: "static"
  },
  {
    question: "How do you specify multiple CSS styles for a single HTML element?",
    options: [
      "Using a comma-separated list of styles",
      "Using a semicolon-separated list of styles",
      "By declaring the styles in separate style tags",
      "By declaring the styles in separate classes"
    ],
    answer: "Using a semicolon-separated list of styles"
  },
  {
    question: "Which CSS property is used to change the text color of an element?",
    options: [
      "color",
      "font-color",
      "text-color",
      "fgcolor"
    ],
    answer: "color"
  },
  {
    question: "What does the CSS 'float' property do?",
    options: [
      "Causes an element to move to the right or left of its container",
      "Causes an element to appear in front of other elements",
      "Takes an element out of the normal document flow and positions it in a specified direction",
      "Specifies the alignment of an element within its container"
    ],
    answer: "Takes an element out of the normal document flow and positions it in a specified direction"
  },
  {
    question: "Which CSS property is used to control the background color of an element?",
    options: [
      "background-color",
      "bgcolor",
      "background-colour",
      "bgcolour"
    ],
    answer: "background-color"
  },
  {
    question: "Which of the following is used to specify multiple background images for an element?",
    options: [
      "background-image",
      "backgrounds",
      "background",
      "multiple-backgrounds"
    ],
    answer: "background"
  },
  {
    question: "How do you specify the background color of a web page?",
    options: [
      "body {background-color: color;}",
      "document {background-color: color;}",
      "html {background-color: color;}",
      "page {background-color: color;}"
    ],
    answer: "body {background-color: color;}"
  },
  {
    question: "What is the purpose of the 'clear' property in CSS?",
    options: [
      "To specify the direction of the text",
      "To control the flow of elements on a web page",
      "To set the size of an element",
      "To set the type of an element"
    ],
    answer: "To control the flow of elements on a web page"
  },
  {
    question: "What is the difference between padding and margin in CSS?",
    options: [
      "Padding is inside the element, while margin is outside the element",
      "Padding is outside the element, while margin is inside the element",
      "Padding and margin are the same thing",
      "Padding is used to set the size of an element, while margin is used to control the flow of elements on a web page"
    ],
    answer: "Padding is inside the element, while margin is outside the element"
  },
  {
    question: "What does the CSS display property do?",
    options: [
      "Sets the visibility of an element",
      "Sets the layout of an element",
      "Sets the type of cursor to be displayed",
      "Sets the opacity of an element"
    ],
    answer: "Sets the layout of an element"
  },
  {
    question: "Which of the following CSS property is used to control the text size of an element?",
    options: [
      "font-size",
      "text-size",
      "size",
      "font"
    ],
    answer: "font-size"
  },
  {
    question: "What is the CSS selector that targets an element based on its class name?",
    options: [
      ".",
      "#",
      ":",
      "@"
    ],
    answer: "."
  },
  {
    question: "What is the CSS property that is used to control the font weight of an element?",
    options: [
      "font",
      "font-weight",
      "weight",
      "font-style"
    ],
    answer: "font-weight"
  },
  {
    question: "What is the correct way to write CSS code in an HTML document?",
    options: [
      "<style> tag in the <head> section",
      "<css> tag in the <body> section",
      "External CSS file linked in the <head> section",
      "Inline CSS written in the HTML elements"
    ],
    answer: "External CSS file linked in the <head> section"
  },
  {
    question: "Which CSS property is used to hide an HTML element?",
    options: [
      "visibility",
      "opacity",
      "display",
      "none"
    ],
    answer: "display: none;"
  },
  {
    question: "Which CSS selector is used to select all elements of a specific type?",
    options: [
      "#id",
      ".class",
      "element",
      "*"
    ],
    answer: "element"
  },
  {
    question: "What is the purpose of CSS Box Model?",
    options: [
      "To display images",
      "To display text",
      "To define the size and spacing of elements on a web page",
      "To define the font and color of text"
    ],
    answer: "To define the size and spacing of elements on a web page"
  },
  {
    question: "What is the correct way to combine multiple CSS classes into one selector?",
    options: [
      ".class1 .class2",
      "#id1 #id2",
      ".class1, .class2",
      "#id1, #id2"
    ],
    answer: ".class1, .class2"
  },
  {
    question: "What is the difference between visibility: hidden and display: none in CSS?",
    options: [
      "Visibility: hidden hides an element, but it still takes up space on the page. Display: none hides an element and it does not take up any space.",
      "Visibility: hidden hides an element and it does not take up any space. Display: none hides an element, but it still takes up space on the page.",
      "Both visibility: hidden and display: none hide an element, but visibility: hidden takes up space on the page.",
      "Both visibility: hidden and display: none hide an element and do not take up any space."
    ],
    answer: "Visibility: hidden hides an element, but it still takes up space on the page. Display: none hides an element and it does not take up any space."
  },
  {
    question: "What is the difference between responsive and adaptive design in CSS?",
    options: [
      "Responsive design changes the layout of a website based on the screen size of the device, while adaptive design changes the layout based on predefined screen sizes.",
      "Responsive design changes the layout of a website based on predefined screen sizes, while adaptive design changes the layout based on the screen size of the device.",
      "Both responsive and adaptive design change the layout of a website based on the screen size of the device.",
      "Both responsive and adaptive design change the layout of a website based on predefined screen sizes."
    ],
    answer: "Responsive design changes the layout of a website based on the screen size of the device, while adaptive design changes the layout based on predefined screen sizes."
  }

  ]


  const jQuery =[
    {
      "question": "Which of the following is used to select an element in jQuery?",
      "options": [
        "$('element')",
        "$.element",
        "$element",
        "None of the above"
      ],
      "answer": "$('element')"
    },
    {
      "question": "Which of the following is used to bind an event to an element in jQuery?",
      "options": [
        "$('element').bind()",
        "$('element').on()",
        "$('element').attach()",
        "$('element').addEventListener()"
      ],
      "answer": "$('element').on()"
    },
    {
      "question": "Which of the following is used to hide an element in jQuery?",
      "options": [
        "$('element').hide()",
        "$('element').visible(false)",
        "$('element').display(none)",
        "$('element').remove()"
      ],
      "answer": "$('element').hide()"
    },
    {
      "question": "Which of the following is used to get the value of an input element in jQuery?",
      "options": [
        "$('element').value",
        "$('element').val()",
        "$('element').getValue()",
        "$('element').getAttribute('value')"
      ],
      "answer": "$('element').val()"
    },
    {
      "question": "Which of the following is used to add a class to an element in jQuery?",
      "options": [
        "$('element').addClass()",
        "$('element').addStyle()",
        "$('element').appendClass()",
        "$('element').setAttribute('class', 'class-name')"
      ],
      "answer": "$('element').addClass()"
    },
    {    question: "What is the difference between the .click() and .on('click', function()) methods in jQuery?",    options: [      "There is no difference, both methods do the same thing",      ".click() is a shorthand method while .on('click', function()) is more flexible",      ".click() is an event method while .on('click', function()) is a utility method",      ".click() is a deprecated method while .on('click', function()) is the recommended method"    ],
    answer: ".click() is a shorthand method while .on('click', function()) is more flexible"
  },
  {
    question: "What does the .each() method in jQuery do?",
    options: [
      "It iterates over the set of elements, executing a function for each element",
      "It selects elements that match a specified selector",
      "It returns the first element in a set of elements that match a specified selector",
      "It filters out elements that match a specified selector"
    ],
    answer: "It iterates over the set of elements, executing a function for each element"
  },
  {
    question: "What is the difference between the .hide() and .fadeOut() methods in jQuery?",
    options: [
      "There is no difference, both methods do the same thing",
      ".hide() immediately hides an element while .fadeOut() gradually hides an element over a specified duration",
      ".hide() is a deprecated method while .fadeOut() is the recommended method",
      ".fadeOut() immediately hides an element while .hide() gradually hides an element over a specified duration"
    ],
    answer: ".hide() immediately hides an element while .fadeOut() gradually hides an element over a specified duration"
  },
  {
    question: "What is the difference between the .slideUp() and .slideDown() methods in jQuery?",
    options: [
      "There is no difference, both methods do the same thing",
      ".slideUp() hides an element by sliding it up while .slideDown() shows an element by sliding it down",
      ".slideDown() hides an element by sliding it down while .slideUp() shows an element by sliding it up",
      "Both .slideUp() and .slideDown() are deprecated methods in jQuery"
    ],
    answer: ".slideUp() hides an element by sliding it up while .slideDown() shows an element by sliding it down"
  },
  {
    question: "What does the .prop() method in jQuery do?",
    options: [
      "It retrieves the property value of the first element in a set of elements that match a specified selector",
      "It sets the property value of all elements in a set of elements that match a specified selector",
      "It retrieves or sets the property value of an element, depending on whether an argument is passed or not",
      "It returns a new set of elements that match a specified selector"
    ],
    answer: "It retrieves or sets the property value of an element, depending on whether an argument is passed or not"
  }
]


const Git = [
  {    question: "What does the 'git clone' command do?",    options: [      "Initialize a new local repository",      "Create a new branch",      "Download a remote repository to your local machine",      "Upload local changes to a remote repository"    ],
    answer: "Download a remote repository to your local machine"
  },
  {
    question: "What is the purpose of the 'git branch' command?",
    options: [
      "To delete a branch",
      "To list all local branches",
      "To switch between branches",
      "To create a new branch"
    ],
    answer: "To list all local branches"
  },
  {
    question: "What does the 'git push' command do?",
    options: [
      "Download changes from a remote repository",
      "Upload local changes to a remote repository",
      "Delete a remote branch",
      "Create a new remote repository"
    ],
    answer: "Upload local changes to a remote repository"
  },
  {
    question: "What is the purpose of the 'git pull' command?",
    options: [
      "Discards changes that have not been committed",
      "Download changes from a remote repository",
      "Merge changes from one branch into another",
      "Delete a remote branch"
    ],
    answer: "Download changes from a remote repository"
  },
  {
    question: "What does the 'git merge' command do?",
    options: [
      "Upload local changes to a remote repository",
      "Download changes from a remote repository",
      "Merge changes from one branch into another",
      "Delete a remote branch"
    ],
    answer: "Merge changes from one branch into another"
  },
  {    question: "What does the command 'git init' do?",    options: [      "Clones a repository from a remote source",      "Initializes a new Git repository",      "Updates the current repository to the latest version",      "Stashes changes in the current repository"    ],
    answer: "Initializes a new Git repository"
  },
  {
    question: "What is the purpose of the 'git stash' command?",
    options: [
      "Stores changes that have not been committed",
      "Upload local changes to a remote repository",
      
      "Restores changes that have been stashed",
      "Commits changes that have been stashed"
    ],
    answer: "Stores changes that have not been committed"
  },
  {
    question: "What does the 'git checkout' command do?",
    options: [
      "Switches to a different branch in the repository",
      "Discards changes in the current branch",
      "Merges changes from one branch into another",
      "Stashes changes in the current branch"
    ],
    answer: "Switches to a different branch in the repository"
  },
  {
    question: "What is the difference between 'git pull' and 'git fetch'?",
    options: [
      "Git pull updates the current branch with changes from a remote repository, while git fetch fetches changes to all branches",
      "Git pull updates the current branch with changes from a remote repository, while git fetch fetches changes to a specific branch",
      "Git fetch updates the current branch with changes from a remote repository, while git pull fetches changes to all branches",
      "Git fetch updates the current branch with changes from a remote repository, while git pull fetches changes to a specific branch"
    ],
    answer: "Git pull updates the current branch with changes from a remote repository, while git fetch fetches changes to all branches"
  },
  {
    question: "What is the purpose of the 'git rebase' command?",
    options: [
      "Rebases the current branch onto a specified branch",
      "Merges changes from one branch into another",
      "Discards changes in the current branch",
      "Stashes changes in the current branch"
    ],
    answer: "Rebases the current branch onto a specified branch"
  }

]


let upperSectionBgColor =""

  switch (id) {
    case "HTML":
      renderQuestion = HTML;
      upperSectionBgColor ="#F1662A"
      

      break;
    case "Javascript":
      renderQuestion = Javascript;
      upperSectionBgColor ="#F2D916"
      

      break;
    case "ReactJs":
      renderQuestion = ReactJs;
      upperSectionBgColor ="#00D8FF"

      break;
    case "CSS":
      renderQuestion = CSS;
      upperSectionBgColor ="#1572B6"

      break;
    case "jQuery":
      renderQuestion = jQuery;
      upperSectionBgColor ="#21609B"

      break;
    case "Git":
      renderQuestion = Git;

      break;

    default:
      break;
  }

  console.log("users annswer ouside here", userAnswers, showAnswers);
  function handleClick(value) {
    setUserAnswers([...userAnswers, optionSelected]);
    setOptionSelected('')

    if (currentQuestion < renderQuestion.length - 1 && value === "next") {
      console.log("users annswer here", userAnswers);
      if (checkAnswer === "correct") {
        setScore((prev) => prev + 1);
      }
      setCurrentQuestion((prev) => prev + 1);
      setCheckAnswer("wrong");
    } else {
      setResult(true);
      setNavToggle(false);
    }
  }

  function optionClick(option, question) {
    setOptionBgColor(option);
    if (option === question.answer) {
      setCheckAnswer("correct");
      setOptionSelected(option);
    } else {
      setCheckAnswer("wrong");
      setOptionSelected(option);
    }
  }

  return result ? (
    <div className="result-container">
      <p className="h1">{id} Quiz Result.</p>
      <div className="percent">
        <div className="score-bar">
          <div className="marks">
            <svg>
              <circle cx="70" cy="70" r="55"></circle>
              <circle
                style={{
                  strokeDashoffset: `calc(346 - (346 * ${
                    (score / renderQuestion.length) * 100
                  }) / 100)`,
                }}
                cx="70"
                cy="70"
                r="55"
              ></circle>
            </svg>
            <div className="number">
              <div>
                {" "}
                <span className="score">{score}</span>{" "}
                <span className="slash">/</span> {renderQuestion.length}{" "}
              </div>
              <p>score</p>
            </div>
          </div>
        </div>
        <div className="message">
          <p>
            {(score / renderQuestion.length) * 100 >= 40
              ? "Congratulations !"
              : "Keep Trying !"}{" "}
          </p>
          <p>
            You have{" "}
            <span
              className={
                (score / renderQuestion.length) * 100 >= 40
                  ? "result-color-green"
                  : "result-color-red"
              }
            >
              {(score / renderQuestion.length) * 100 >= 40
                ? "passed"
                : "failed"}
            </span>{" "}
            this quiz with{" "}
            <span className="percent-color">
              {((score / renderQuestion.length) * 100).toFixed(0)}%
            </span>
            .
          </p>
        </div>
      </div>
      <div className="answers">
        <div className="check correct">
          <div>
            <p>{score}</p>
            <img src={check} alt="" />
          </div>
          <p>Correct Answers</p>
        </div>
        <div className="check wrong">
          <div>
            <p>{renderQuestion.length - score}</p>
            <img src={cross} alt="" />
          </div>
          <p>Wrong Answers</p>
        </div>
      </div>
      <div className="buttons">
        <button
          onClick={() => {
            setShowAnswers(true);
            setResult(false);
          }}
        >
          Check Answers
        </button>
        <a href={`/quiz/${id}`}>
        <button
        id="try-quiz"
          onClick={() => {
            setResult(false);
            setUserAnswers([]);
          }}
        >
          Try Quiz Again
        </button>
        </a>
      </div>
    </div>
  ) : showAnswers ? (
    <div className="show-answer-container">
      <p className="h1">{id} Quiz Result.</p>
      <p className="score">
        Your score {score} / {renderQuestion.length}
      </p>

      <ol>
        {renderQuestion.map((question, index) => (
          <li>
            <p className="question">{question.question}</p>
            <ul>
              {question.options.map((option) => (
                <li
                  style={
                    question.answer === option
                      ? { backgroundColor: "#C9FFB6" }
                      : userAnswers[index] === option &&
                        userAnswers[index] !== question.answer
                      ? { backgroundColor: "#FFB1B1" }
                      : {}
                  }
                >
                  <div className="option">{option}</div>

                  {question.answer === option ||
                  userAnswers[index] === option ? (
                    <div>
                      <p>
                        {userAnswers[index] === question.answer ||
                        userAnswers[index] === option
                          ? "Your"
                          : "Correct"}{" "}
                        answer
                      </p>
                      <img
                        src={
                          userAnswers[index] === option &&
                          userAnswers[index] !== question.answer
                            ? crossblack
                            : checkblack
                        }
                        alt=""
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ol>
    </div>
  ) : (
    <div className="quiz-page">
      <div className="container">
        <div 
        style={{ backgroundColor: upperSectionBgColor }}
        className="upper-section">
          <div className="left">
            <p className="h1">
              {id} <br /> Quiz
            </p>
            <p className="h2">
              Total Questions: <span>{renderQuestion.length}</span>{" "}
            </p>
          </div>

          <div className="right">
            <img src={quizImg} alt="" />
          </div>
        </div>

        <div className="lower-section">
          <p className="float-right">
            {currentQuestion + 1} / {renderQuestion.length}{" "}
          </p>
          <p className="question">{renderQuestion[currentQuestion].question}</p>
          <div className="options">
            {renderQuestion[currentQuestion].options.map((option, index) => (
              <div
                style={{
                  backgroundColor: optionBgColor === option ? "#d7f3ff" : "",
                }}
                onClick={() =>
                  optionClick(option, renderQuestion[currentQuestion])
                }
                key={index}
              >
                {option}
              </div>
            ))}
          </div>
          <div className="buttons">
            <button onClick={() => handleClick("next")} className="next">
              {currentQuestion > renderQuestion.length - 2 ? "Submit" : `Next`}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Quiz;
